import React from 'react';
import moduleStyles from './Lab2Wrapper.module.scss';
var i18n = require('@cdo/locale');
export var ErrorUI = function (_a) {
    var message = _a.message;
    return (React.createElement("div", { id: "page-error-container", className: moduleStyles.pageErrorContainer },
        React.createElement("div", { id: "page-error", className: moduleStyles.pageError },
            React.createElement("img", { className: moduleStyles.pageErrorImage, src: "/shared/images/sad-bee-avatar.png" }),
            React.createElement("div", null, i18n.loadingError()),
            message && (React.createElement("div", { className: moduleStyles.pageErrorMessage },
                "(",
                message,
                ")")))));
};
export var ErrorFallbackPage = function () { return (React.createElement("div", { id: "lab-container", className: moduleStyles.labContainer },
    React.createElement(ErrorUI, null))); };
